module.exports = __webpack_public_path__ + "static/media/vive-create-feature-b.cede6ecf.png";